import { Link } from 'react-router-dom';
import { companyInfo } from '@/mocks/company';

const features = [
  { icon: 'ri-tools-line', title: 'Serviço Técnico Oficial', desc: 'Reparos e manutenções com peças originais de fábrica.' },
  { icon: 'ri-global-line', title: 'Atendimento Nacional', desc: 'Atendemos todo o Brasil com entrega rápida.' },
  { icon: 'ri-shield-check-line', title: 'Garantia de Qualidade', desc: 'Equipamentos importados com certificação e procedência garantida.' },
  { icon: 'ri-customer-service-2-line', title: 'Suporte Dedicado', desc: 'Nossa equipe responde via WhatsApp com agilidade.' },
];

export default function CompanySection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="grid grid-cols-2 gap-3">
              <div className="w-full h-52 md:h-64 rounded-2xl overflow-hidden">
                <img
                  alt="Estoque de máquinas de solda geomembrana"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/muchas-rojas-con-cajas-A8543EvBNjfW0ORg.jpg"
                />
              </div>
              <div className="w-full h-52 md:h-64 rounded-2xl overflow-hidden mt-6 md:mt-8">
                <img
                  alt="Soldadoras para geomembrana disponíveis"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=486,fit=crop/A0xVvobDbRIBrVE7/muchas-soldadoras-rojas-mxB7kMa8jKhoPalp.jpg"
                />
              </div>
            </div>
            <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-primary-500 text-white text-sm px-5 py-2 rounded-full whitespace-nowrap font-bold">
              +{companyInfo.years} anos de experiência
            </div>
          </div>

          <div>
            <span className="text-primary-500 text-xs uppercase tracking-widest mb-3 block">Sobre Nós</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight mb-5">
              Especialistas<br /><span className="text-primary-500">em Geomembrana</span>
            </h2>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">
              A <strong className="text-foreground-950 font-bold">{companyInfo.name}</strong> tem mais de <strong className="text-foreground-950 font-bold">{companyInfo.years} anos no mercado</strong>, sediada em Florianópolis (SC, Brasil). Somos importadores e distribuidores oficiais de <strong className="text-foreground-950 font-bold">máquinas de solda geomembrana</strong>.
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-8">
              Nossos equipamentos atendem projetos de <strong className="text-foreground-950 font-bold">aterros sanitários, reservatórios, barragens, canais de irrigação e mineração</strong> em todo o Brasil — com suporte técnico especializado e peças originais de fábrica.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((f) => (
                <div key={f.title} className="flex items-start gap-3 p-4 rounded-xl bg-white border border-background-200/70">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                    <i className={`${f.icon} text-primary-600`} />
                  </div>
                  <div>
                    <h4 className="text-foreground-900 font-bold text-sm mb-0.5 uppercase">{f.title}</h4>
                    <p className="text-foreground-500 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6">
              <Link
                to="/sobre"
                className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm font-bold uppercase tracking-wide transition-colors cursor-pointer"
              >
                Conheça a empresa <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}